<button mat-flat-button class="btn-tertiary" (click)="onClick()">
  <span class="text">{{symbol}} de détails</span>
</button>
